export enum TransactionTypeEnum {
  DEPOSIT = 1,
  WITHDRAWAL = 2,
}
